/**
 * Value for an input's `autoComplete` prop that stops the browser from
 * offering its saved entries (addresses, names, past values) in the booking
 * forms.
 *
 * Why not just "off"? Chrome ignores autocomplete="off" on any field it
 * guesses is an address -- and "Pick-up: Airport, Hotel..." looks like one --
 * so its address dropdown covered our own location suggestions. A value the
 * browser doesn't recognise makes it leave the field alone.
 *
 * <input autoComplete={BROWSER_AUTOFILL_OFF} />
 */
export const BROWSER_AUTOFILL_OFF = "tlf-no-autofill";
